import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const ConfirmModal = memo(props => {
  const { show, data, title, onClick, subtitle, setShowConfirmModal, confirmModalBtnText } = props;

  return show ? (
    <div
      data-test="confirm-modal"
      className="h-screen w-screen fixed top-0 left-0 flex justify-center items-center transition-all duration-1000 ease-in-out z-[1001]"
    >
      <button
        type="button"
        aria-label="Close modal"
        className="absolute inset-0 w-full h-full backdrop-blur-sm border-none bg-transparent cursor-pointer"
        onClick={() => setShowConfirmModal(false)}
      />
      <div className="w-3/6 relative bg-white rounded-md z-50 shadow-2xl opacity-100 duration-1000 ease-in-out">
        <div className="flex justify-end">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-dark-night"
            onClick={() => setShowConfirmModal(false)}
          >
            <i className="material-icons text-[24px] m-4 !text-inherit">close</i>
          </button>
        </div>
        <h2 className=" mt-4 font-bold text-lg text-center">{title}</h2>

        <div className="flex flex-col justify-center items-center mt-8 ">
          {data.map(el => (
            <button
              key={uuidv4()}
              type="button"
              className=" text-dark-night border border-dark-night focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 flex items-center justify-center"
            >
              <p className="font-bold text-inherit mr-4">{`${subtitle} ${el}`}</p>
            </button>
          ))}
        </div>

        <div className="flex justify-center pb-4  mt-8">
          <button
            data-test="confirm-modal-submit"
            type="button"
            className="bg-primary active:bg-orange-300 hover:scale-x-105 hover:scale-y-105 transition duration-500 z-30 shadow-md  w-32 h-12 rounded-lg text-white text-sm font-bold px-2"
            onClick={() => onClick()}
          >
            {confirmModalBtnText}
          </button>
        </div>
      </div>
    </div>
  ) : null;
});

ConfirmModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  setShowConfirmModal: PropTypes.func,
  confirmModalBtnText: PropTypes.string,
  data: PropTypes.array,
};

export default ConfirmModal;
